"use client";

import posthog from "posthog-js";
import { Instagram, Facebook } from "lucide-react";
import { BUSINESS } from "@/lib/constants";

export function DirectionsLink() {
  return (
    <a
      href={BUSINESS.googleMapsUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="text-warm-gray-light hover:text-terracotta transition-colors"
      onClick={() => posthog.capture("directions_clicked")}
    >
      {BUSINESS.address.street}
      <br />
      {BUSINESS.address.city}, {BUSINESS.address.state}{" "}
      {BUSINESS.address.zip}
    </a>
  );
}

export function SocialLinks() {
  return (
    <div className="flex items-center gap-4">
      <a
        href={BUSINESS.social.instagram}
        target="_blank"
        rel="noopener noreferrer"
        className="w-10 h-10 bg-terracotta-light/20 rounded-full flex items-center justify-center hover:bg-terracotta hover:text-white text-terracotta transition-colors"
        aria-label="Instagram"
        onClick={() => posthog.capture("social_link_clicked", { platform: "instagram" })}
      >
        <Instagram size={20} />
      </a>
      <a
        href={BUSINESS.social.facebook}
        target="_blank"
        rel="noopener noreferrer"
        className="w-10 h-10 bg-terracotta-light/20 rounded-full flex items-center justify-center hover:bg-terracotta hover:text-white text-terracotta transition-colors"
        aria-label="Facebook"
        onClick={() => posthog.capture("social_link_clicked", { platform: "facebook" })}
      >
        <Facebook size={20} />
      </a>
    </div>
  );
}
